<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col sm="12">
                    <h2>Flight</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="formData.flight.countryOfDeparture != 'Others'">
                    <p>
                        <span class="label">Country of Departure</span>
                        <span class="inputText">{{this.formData.flight.countryOfDeparture}}</span>
                    </p>
                </b-col>
                <b-col sm="12" v-if="formData.flight.countryOfDeparture == 'Others'">
                    <p>
                        <span class="label">Country of Departure</span>
                        <span class="inputText">{{this.formData.flight.countryOfDepartureOthers}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Preferred Flight</span>
                        <span class="inputText">{{this.formData.flight.flight}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Airline Frequent Flyer Type</span>
                        <span class="inputText">{{this.formData.flight.frequentFlyerType}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Airline Frequent Flyer Number</span>
                        <span class="inputText">{{this.formData.flight.frequentFlyerNumber}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Special Requests</span>
                        <span class="inputText">{{this.formData.flight.requests}}</span>
                    </p>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Flight Itinerary</span>
                        <span class="inputText">{{this.formData.flight.flightItinerary}}</span>
                    </p>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col sm="12">
                    <h2>Particulars</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Family Name</span>
                        <span class="inputText">{{this.formData.particulars.lastName}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Given Name</span>
                        <span class="inputText">{{this.formData.particulars.firstName}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Job Title</span>
                        <span class="inputText">{{this.formData.particulars.jobTitle}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Department</span>
                        <span class="inputText">{{this.formData.particulars.department}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Date of Birth</span>
                        <span class="inputText">{{dateOfBirth}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Nationality</span>
                        <span class="inputText">{{this.formData.particulars.nationality}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Passport Number</span>
                        <span class="inputText">{{this.formData.particulars.passportNo}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Date of Expiry</span>
                        <span class="inputText">{{expiryDate}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Email</span>
                        <span class="inputText">{{this.formData.particulars.email}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Emergency Name</span>
                        <span class="inputText">{{this.formData.particulars.emergencyName}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Emergency Relationship</span>
                        <span class="inputText">{{this.formData.particulars.emergencyRelationship}}</span>
                    </p>
                </b-col>
                <b-col sm="12">
                    <p>
                        <span class="label">Emergency Contact</span>
                        <span class="inputText">{{this.formData.particulars.emergencyContact}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <p>
                        <span class="label">Remarks</span>
                        <span class="inputText">{{this.formData.particulars.remarks}}</span>
                    </p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'Summary',
    props: [ 'formData', 'dateFormatMoment' ],
    computed: {
        dateOfBirth() {
            window.console.log(this.formData.particulars.dateOfBirth);
            return moment(this.formData.particulars.dateOfBirth).format(this.dateFormatMoment);
        },
        expiryDate() {
            window.console.log(this.formData.particulars.passportExpiry);
            
            return moment(this.formData.particulars.passportExpiry).format(this.dateFormatMoment);
        }
    },
    mounted: function () {
    }
}
</script>

<style lang="less" scoped>
    .label {
        color: lighten(@grey,10%);
    }
    .inputText {
        border-top: 1px solid @blue;
        display: block;
        margin-top:0.2rem;
        min-height: 1.5rem;
        padding: 0.1rem;
    }
</style>